// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__M8xoz","sm":"Tag_sm__OQIPy"};